import * as React from 'react';
import CurationStore from '../stores/curation_store';
import CuratedSetToggle from './curated_set_toggle';

class CurationAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = CurationStore.getState();
    this.onCurationStoreUpdated = this.onCurationStoreUpdated.bind(this);
  }

  componentDidMount() {
    CurationStore.listen(this.onCurationStoreUpdated);
  }

  componentWillUnmount() {
    CurationStore.unlisten(this.onCurationStoreUpdated);
  }

  onCurationStoreUpdated() {
    this.setState(CurationStore.getState());
  }

  get listingSets() {
    return this.state.listing_curated_sets;
  }

  get hasListingSets() {
    return this.listingSets.length > 0;
  }

  renderSets() {
    return this.listingSets.map((set) => <CuratedSetToggle key={set.curated_set_id} set={set} />);
  }

  render() {
    return (
      <div>
        {this.state.error}
        {this.renderSets()}
      </div>
    );
  }
}

export default CurationAdmin;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/curation/admin.jsx